import styled from 'styled-components'
import { breakpoints } from 'helpers/utils'

const { mobile } = breakpoints

export const StyledCompareToday = styled.span`

`

export const StyledCompareWith = styled.span`

`

export const StyledDetailsContainer = styled.div`
& .compare_btn_wrapper .select_container{
	right: -10px;
	@media(max-width: 768px){
		top: 30px;
	}
}
& .salesBar .dchart__mainBlock{
	margin-bottom: 0;
}
& .dchart {
		&__title {
				@media (${mobile}) {
						margin: 0px;
				}
		}
}
`

export const StyledCompareBtnWrapper = styled.div`
position: relative;
& .select_container{
	z-index: 4;
	background-color: white;
	position: absolute;
	min-width: 319px;
	right: 0;
	left: unset;
	top: 39px;
	padding: 20px;
	box-shadow: 0px 0px 7px 0 rgba(0, 0, 0, 0.15);
	border: 1px solid #CDCDCD;

	@media (max-width: 1200px){
		top: 31px;
		min-width: 339px;
	}

	@media (max-width: 768px){
		top: 41px;
		min-width: 381px;
	}

	@media (max-width: 453px){
		min-width: 300px;
	}

	@media (max-width: 369px){
		min-width: 255px;
		&>div{
			margin-bottom: 6px;
		}
	}

	& span{
		font-size: 13px;
		font-weight: 400;
		color: #434343;
		border-color: #CDCDCD !important;
		@media (max-width: 768px){
			font-size: 15px;
		}
		@media (max-width: 453px){
			font-size: 11px;
		}
		@media (max-width: 369px){
			font-size: 9px;
		}
	}
	& .compare_today__active span{
		color: #4A90E2;
		border-color: #4A90E2 !important;
		font-weight: 500;
		&::after{
			background-color: #4A90E2;
			width: 9px;
    		height: 9px;
			top: 50%;
			transform: translate(0, -50%);
		}
	}
	& .compare_with__active span{
		color: #F2874F;
		border-color: #F2874F !important;
		font-weight: 500;
		&::after{
			background-color: #F2874F;
			width: 9px;
    		height: 9px;
			top: 50%;
			transform: translate(0, -50%);
		}
	}

}
`

export const StyledHeader = styled.div`
	padding-bottom: 20px;
	&:after {
		position: absolute;
		content: ' ';
		height: 1px;
		width: 80%;
		top: 183px;
		z-index: 3;
		left: 50%;
		transform: translate(-50%, 0);
		background: linear-gradient(45deg, #f9f9f8, #CDCDCD, #CDCDCD, #f9f9f8);
	}
	@media (max-width: 1200px) and  (max-height: 610px){
		&:after {
			top: 171px;
		}
	}
	@media (max-width: 768px) {
		padding-bottom: 15px;
		&:after {
			top: 223px;
		}
	}
	@media (max-width: 768px) and  (max-height: 610px){
		&:after {
			top: 180px;
		}
	}
	@media (max-width: 512px) {
		&:after {
			top: 212px;
		}
	}
	@media (max-width: 512px) and  (max-height: 610px){
		&:after {
			top: 169px;
		}
	}
	@media (max-width: 416px) {
		&:after {
			top: 202px;
		}
	}
	@media (max-width: 416px) and  (max-height: 610px){
		&:after {
			top: 153px;
		}
	}
	@media (max-width: 378px) {
		&:after {
			top: 192px;
		}
	}
	@media (max-width: 378px) and  (max-height: 610px){
		&:after {
			top: 150px;
		}
	}
	& .header_branchinfo_wrapper{
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		& .header_branchinfo{
			& .title{
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				max-width: 275px;
				display: block;
				@media (max-width: 768px){
					max-width: 142px;
				}
				@media (max-width: 570px){
					max-width: 142px;
					font-size: 24px;
				}
				@media (max-width: 491px){
					font-size: 20px;
				}
				@media (max-width: 400px){
					font-size: 18px;
				}
				@media (max-width: 350px){
					font-size: 15px;
				}
			}
		}
		& .header_item_date{
			margin-left: 40px;
			@media (max-width: 768px){
				margin-left: 0px;
			}
			& .formated_date {
				max-width: none;
			}
			& .pickerWrapper{
				margin-left: 0;
				width: fit-content;
				background-color: white;
				float: none;
				& i{
					font-size: 13px;
				}
			}
			& .calendarShown{
				left: 0;
				@media (max-width: 768px) {
					left: 50%;
				}
			}
			@media (max-width: 512px){
				& .pickerWrapper{
					height: 35px;
					& i{
						font-size: 11px;
					}
				}
			}
			@media (max-width: 416px){
				& .pickerWrapper{
					height: 30px;
					& i{
						font-size: 9px;
					}
				}
			}
			@media (max-width: 400px){
				& .pickerWrapper{
					height: 25px;
				}
			}
		}
	}

	& .header_item{
		& .logout_wrapper{
			float: right;
			@media (max-width: 1200px){
				display: none;
			}
			& a{
				text-decoration: none;
				font-size: 14px;
				font-weight: 500;
				color: #B0B0B0;
			}
			& .logout {
				display: flex;
				align-items: center;
				margin-top: 12px;
			}
			&:hover{
				& svg path {
					stroke: #434343;
				}
				& a{
					color: #434343;
				}
			}
		}
	}

	@media (max-width: 1200px) and  (max-height: 610px){
		margin-top: 9px;
	}

	@media (max-width: 768px){
		margin-top: 29px;
	}

	@media (max-width: 768px) and  (max-height: 610px){
		margin-top: 39px;
	}

	@media (max-width: 416px) and  (max-height: 610px){
		margin-top: 30px;
	}
`
